module.exports = __webpack_public_path__ + "img/hand-fist.623dc381.svg";